import React, { Component } from 'react';
import PropTypes from "prop-types";

import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';

import axios from 'axios';
import { push as Menu } from 'react-burger-menu'
import { default as ReactSelect } from "react-select";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Lightbox from './react-images';
import { Scrollbars } from 'react-custom-scrollbars';
import './App.css';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import Clipboard from 'react-clipboard.js';
import Switch from 'react-toggle-switch'
import 'react-toggle-switch/dist/css/switch.min.css';
import Modal from 'react-responsive-modal';

import {WarningBanner} from './WarningBanner'

import LoadGIF from './img/load.gif';
import BlankScreenGrey from './img/400_400_blank_screen_grey.svg';

var qs = require('qs');

//Extend Select module to allow user to select "all"
const Select = props => { 
  if (props.allowSelectAll) {
    if ((props.value.length === props.options.length) && props.value.length>1) {
      return (
        <ReactSelect
          {...props}
          value={[props.allOption]}
          onChange={(selected, { action }) => { props.onChange(selected.slice(1), action)}}
        />
      );
    }

    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props.options]}
        onChange={(selected, { action }) => {
          if (
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange(props.options, action);
          }
          return props.onChange(selected, action);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
};
Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};
Select.defaultProps = {
  allOption: {
    label: "All",
    value: "*"
  }
};

// Define all constants to be used throughout the app
const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    'border': state.isFocused ? 'none' : 'none',
    'box-shadow': state.isFocused ? 'none' : 'none',
    'cursor': 'pointer'
  }),
  option: (base, state) => ({
    ...base,
    'cursor': 'pointer',
    'backgroundColor': state.isDisabled ? null: state.isSelected ? 'rgba(75, 95, 115, 0.2)' : state.isFocused ? 'rgba(75, 95, 115, 0.05)' : null,
    'color': '#000000'
  })
}

const customLightboxStyles = {
  container: {
    background: 'rgba(0, 0, 0, 0.8)',
  },
}


const CancelToken = axios.CancelToken;
let cancel;


// Main
class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      plotData:    {},
      apiBaseURL: '${APP_DQ_API_URL}/',
      // baseURL: 'https://plot.dmf.arm.gov/PLOTS/',
      baseURL: 'https://plot.dmf.arm.gov/PLOTS/',
      // videoThumbBaseURL: 'https://plot.adc.arm.gov/plotbrowser/thumbs/',
      videoThumbBaseURL: 'https://plot.dmf.arm.gov/PLOTS/thumbs/',
      shareLink: '',
      plotsAreLoading: false,
      compPlotsEnabled: false,
      menuIsOpen: true,
      dailyMaxPlots: {}
    }

    this.displayPlots = this.displayPlots.bind(this);
    this.updateShareLink = this.updateShareLink.bind(this)
    this.toggleLoadingOverlay = this.toggleLoadingOverlay.bind(this)
  }

  componentDidMount(){
    this.getBaseURL()
  }

  getBaseURL(){
  	let url = window.location.href;

    //Is local dev instance - hardcoded to aking for now since will likely be only one to use
    if (url.indexOf("localhost") >= 0){
      let username = "aking"
      console.log("HERE - localhost")
      this.setState({
        apiBaseURL: 'http://localhost:7100/',
        baseURL: 'https://dev.arm.gov/~' + username + '/data/tool/dq/',
        videoThumbBaseURL: 'https://dev.arm.gov/~' + username + '/data/tool/dq/thumbs/'
      })
    }
    //Is Production System
    else{

    }
  }
  
  showSettings (event) {
    event.preventDefault();
  }

  displayPlots(data){

    let max_num_plots = {}

    for(let ds in data){
      for (let pt in data[ds]){
        for (let date in data[ds][pt]){

          if (date !== 'description') {
            if (!(date in max_num_plots)){
              max_num_plots[date] = 0
            }
            if(data[ds][pt][date].length > max_num_plots[date]){
              max_num_plots[date] = data[ds][pt][date].length
            }
          }
        }
      }
    }

    this.setState({
      plotData: data,
      plotsAreLoading: false,
      dailyMaxPlots: max_num_plots
    })
  }

  updateShareLink(selectedOptions, compPlotsEnabled){

    let newURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + 'comp='+compPlotsEnabled+'&'
    for(let i=0; i<selectedOptions.sites.length;i++){
      newURL = newURL + 's='+selectedOptions.sites[i]+'&'
    }
    for(let i=0; i<selectedOptions.classes.length;i++){
      newURL = newURL + 'c='+selectedOptions.classes[i]+'&'
    }
    for(let i=0; i<selectedOptions.facilities.length;i++){
      newURL = newURL + 'f='+selectedOptions.facilities[i]+'&'
    }
    for(let i=0; i<selectedOptions.levels.length;i++){
      newURL = newURL + 'l='+selectedOptions.levels[i]+'&'
    }
    for(let i=0; i<selectedOptions.plottypes.length;i++){
      newURL = newURL + 'p='+selectedOptions.plottypes[i]+'&'
    }

    newURL = newURL + 'sd='+selectedOptions.sdate+'&'
    newURL = newURL + 'ed='+selectedOptions.edate+'&'

    this.setState({
      shareLink: newURL
    })
  }

  toggleLoadingOverlay(){
    this.setState({
      plotsAreLoading: true,
    })
  }

  toggleMenu = () => {
    this.setState({
      menuIsOpen: !this.state.menuIsOpen
    })
  }
  handleMenuStateChange = (state) => {
    this.setState({menuIsOpen: state.isOpen})  
  }

  checkTaskStatus = (task_id, callback) => {
    let query_data = {
      'task_id': task_id
    }
    let this_context = this
    axios.post(this.state.apiBaseURL + 'task_status', query_data, {
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    }).then(res => {
      let data = res.data
      if (data['state'] != 'PENDING' && data['status'] != 'Pending' && data['state'] != 'PROGRESS') {
          if ('result' in data) {
              callback(data['result'])
          }
          else {
              callback({})
          }
      }
      else {
          // rerun in 2 seconds
          setTimeout(function() {
              this_context.checkTaskStatus(task_id, callback);
          }, 500);
      }
    })


  }
  
  render () {
    console.log(version)
    let queryStringObj = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
    let hasQueryString = false

    try{
      hasQueryString = queryStringObj.s.length>0 && queryStringObj.c.length>0 && queryStringObj.f.length>0 && queryStringObj.l.length>0 && queryStringObj.p.length>0 && queryStringObj.sd !== "" && queryStringObj.ed !== "";
    }
    catch(e){}
    
    return (
      <CacheBuster
        currentVersion={version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
      >
      <div id="outer-container">
        <WarningBanner/>
        <div style={this.state.plotsAreLoading ? {display:'block'} : {display:'none'}} className='load-overlay'>
        </div>
        <div style={this.state.plotsAreLoading ? {display:'block'} : {display:'none'}} className='centered-div'>
          <p>Loading plots...</p>
          <i className="fas fa-2x fa-spinner load-icon fa-spin"></i>
        </div>
          <Menu onStateChange={(state) => this.handleMenuStateChange(state)} isOpen={this.state.menuIsOpen} noOverlay pageWrapId={ "page-wrap" } outerContainerId={ "outer-container" }>
            <div className='menu-options'>

              <PlotSelectMenu
                apiBaseURL           = {this.state.apiBaseURL}
                checkTaskStatus      = {this.checkTaskStatus}
                displayPlots         = {this.displayPlots}
                queryString          = {queryStringObj}
                hasQueryString       = {hasQueryString}
                updateShareLink      = {this.updateShareLink}
                toggleLoadingOverlay = {this.toggleLoadingOverlay}
              />

            </div>
          </Menu>
         
          <main id="page-wrap">
           <div className='sidebar'>
            <ShareButton shareLink={this.state.shareLink}/>
            <MenuButton toggleMenu={this.toggleMenu}/>
          </div>
            <div className='plot-area'>
            <Scrollbars className='plot-area-scroll' style={{ width: '100%', height: '100%'}} >
              <PlotDisplay 
                plotDisplayData = {this.state.plotData}
                videoThumbBaseURL = {this.state.videoThumbBaseURL}
                baseURL = {this.state.baseURL}
                dailyMaxPlots= {this.state.dailyMaxPlots}
              /> 
             </Scrollbars>
            </div>         
          </main>
          <HelpButton apiBaseURL={this.state.apiBaseURL}/>
        </div>
      </CacheBuster>
    );
  }
}

class HelpButton extends Component{

  constructor(props){
    super(props)

    this.state = {
      isShowingModal: false,
      email: '',
      comment: '',
      sendIsDisabled: false,
      buttonText: 'Send'
    }
  }

  showModal = () => {
    this.setState({isShowingModal: true})
  }
  handleClose = () => {
    this.setState({isShowingModal: false,email:'',comment:''})
  }
  handleEmailChange = (e) => {
    this.setState({email: e.target.value});
  }
  handleCommentChange = (e) => {
    this.setState({comment: e.target.value});
  }

  sendEmail = (email, comment) => {
     let query_data = {
        subject: 'New DQ-Plotbrowser Help Request',
        body: comment,
        to: 'dqtools@arm.gov',
        from: email
      }

    this.setState({sendIsDisabled: true});
    
    axios.post(this.props.apiBaseURL + 'send_email', query_data, {
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    }).then(res => {

      this.setState({buttonText: 'Help Request Sent'});
      setTimeout(() => {
        this.handleClose()
        this.setState({sendIsDisabled: false, buttonText: 'Send'});
      }, 2000);

    }).catch((reason: AxiosError) => {

      this.setState({buttonText: 'Error Sending Request'});
      setTimeout(() => {
        this.handleClose()
        this.setState({sendIsDisabled: false, buttonText: 'Send'});
      }, 2000);
    })
    
  }

  render() {
    return(
      <div>
        <div className="footer">
          <p>© ARM DQ Office | <a onClick={this.showModal} href="#">Need Help?</a></p>
        </div>
        <Modal open={this.state.isShowingModal} onClose={this.handleClose} classNames={{ overlay: 'share-overlay', modal: 'share-modal', closeButton:'share-close-button', closeIcon:'share-close-icon'}} center>
          <div style={{minWidth:250}}>
            <div >
              <h3 style={{margin:0, paddingBottom:20}}>DQ Plotbrowser Help</h3>
            </div>
            <div>
              <p style={{margin:5}}><b>Email Address:</b></p>
              <input onChange={this.handleEmailChange}  placeholder="Enter Email..." value={this.state.email} className='help-modal-input'/>

              <br/>
              <br/>

              <p style={{margin:5}}><b>Description/Comment:</b></p>
              <textarea onChange={this.handleCommentChange} placeholder="Describe the issue or leave a comment..." style={{height:70}} value={this.state.comment} className='help-modal-input'/>

              <br/>
              <br/>

              <button disabled={this.state.sendIsDisabled} onClick={()=>this.sendEmail(this.state.email, this.state.comment)} className="plot-menu-button">{this.state.buttonText}</button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

class MenuButton extends Component{

  render(){
    return(
      <div onClick={this.props.toggleMenu} className='menu-toggle'>
        <i className="fa fa-bars fa-2x"></i>
      </div>
    )
  }
}

class ShareButton extends Component{
  constructor(props){
    super(props)

    this.state = {
      isShowingModal: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClick(){
    this.setState({isShowingModal: true})
  }

  handleClose(){
    this.setState({isShowingModal: false})
  }

  render(){
    return <div>
      <i onClick={this.handleClick} className="fas fa-2x fa-share-alt share"></i>
        <Modal open={this.state.isShowingModal} onClose={this.handleClose} classNames={{ overlay: 'share-overlay', modal: 'share-modal', closeButton:'share-close-button', closeIcon:'share-close-icon'}} center>
          <h3>Share Link</h3>
          <div className="buttonInside">
            <input readOnly value={this.props.shareLink} className='share-link'/>
              <Clipboard data-clipboard-text={this.props.shareLink} className='share-link-button'>
                <Tooltip
                  title="Link Copied"
                  position="bottom"
                  trigger="click"
                  arrow="true"
                  duration='50'
                >
                <i className="fa fa-clipboard fa-lg"></i>
                </Tooltip>
              </Clipboard>
            
          </div>
        </Modal>
      {/* {this.state.isShowingModal &&
     <ModalContainer onClose={this.handleClose}>
        <ModalDialog onClose={this.handleClose}>
          <h1>Share Link</h1>
          <div className='share-link-div'>
            <input className='share-link'></input>
             <Clipboard data-clipboard-text="I'll be copied" className='share-link-button'>
              <i class="fas fa-clipboard fa-2x"></i>
            </Clipboard>
          </div>
         <div className="buttonInside">
            <input className='share-link'/>

            <Clipboard data-clipboard-text="I'll be copied" className='share-link-button'>
              <i className="fa fa-clipboard fa-lg"></i>
            </Clipboard>
          </div>
        </ModalDialog>
      </ModalContainer>}*/}
    </div>
  }
}

// Primary sliding menu UI component
class PlotSelectMenu extends Component {

  constructor(props) {

    super(props);
    this.state = {
      selectedSites:          [],
      selectedClasses:        [],
      selectedFacilities:     [],
      selectedLevels:         [],
      selectedPlottypes:      [],
      siteOptions:            [],
      classOptions:           [],
      facilityOptions:        [],
      levelOptions:           [],
      plottypeOptions:        [],
      siteIsDisabled:         true,
      siteIsLoading:          false,
      siteAllowSelectAll:     false,
      classIsDisabled:        true,
      classAllowSelectAll:    false,
      classIsLoading:         false,
      facilityIsDisabled:     true,
      facilityAllowSelectAll: false,
      facilityIsLoading:      false,
      levelIsDisabled:        true,
      levelAllowSelectAll:    false,
      levelIsLoading:         false,
      plottypeIsDisabled:     true,
      plottypeAllowSelectAll: false,
      plottypeIsLoading:      false,
      datePickerIsDisabled:   true,
      getPlotsIsDisabled:     true,
      shiftKeyIsPressed:      false,
      closeOnSelect:          true,
      showDateArrows:         false,
      dateArrowNumDays:       1,
      sitePlaceholder:        '--',
      classPlaceholder:       '--',
      facilityPlaceholder:    '--',
      levelPlaceholder:       '--',
      plottypePlaceholder:    '--',
      startDate:              moment().startOf('day'),
      endDate:                moment().startOf('day'),
      allDates:               [],
      minDate:                moment().startOf('day'),
      maxDate:                moment().startOf('day'),
      plotRequestData:        '',
      compPlotsEnabled:       false,
    };
    this.handleSiteChange       = this.handleSiteChange.bind(this);
    this.handleClassChange      = this.handleClassChange.bind(this);
    this.handleFacilityChange   = this.handleFacilityChange.bind(this);
    this.handleLevelChange      = this.handleLevelChange.bind(this);
    this.handlePlottypeChange   = this.handlePlottypeChange.bind(this);
    this.handleDateChange       = this.handleDateChange.bind(this);
    this.handleKeyDown          = this.handleKeyDown.bind(this);
    this.handleKeyUp            = this.handleKeyUp.bind(this);
    this.handleDateArrowClick   = this.handleDateArrowClick.bind(this);
    this.updateMenu             = this.updateMenu.bind(this);
    this.getPlots               = this.getPlots.bind(this);
    this.toggleCompPlots        = this.toggleCompPlots.bind(this);
  }

  componentDidMount(){
    if(this.props.hasQueryString){
      this.props.toggleLoadingOverlay()
      let compPlotsEnabled        = this.props.queryString.comp == "true"
      let querySelectedSites      = Array.isArray(this.props.queryString.s) ? this.props.queryString.s.map((str, i) => ({ value: str, label: str })) : [this.props.queryString.s].map((str, i) => ({ value: str, label: str }))
      let querySelectedClasses    = Array.isArray(this.props.queryString.c) ? this.props.queryString.c.map((str, i) => ({ value: str, label: str })) : [this.props.queryString.c].map((str, i) => ({ value: str, label: str }))
      let querySelectedFacilities = Array.isArray(this.props.queryString.f) ? this.props.queryString.f.map((str, i) => ({ value: str, label: str })) : [this.props.queryString.f].map((str, i) => ({ value: str, label: str }))
      let querySelectedLevels     = Array.isArray(this.props.queryString.l) ? this.props.queryString.l.map((str, i) => ({ value: str, label: str })) : [this.props.queryString.l].map((str, i) => ({ value: str, label: str }))
      let querySelectedPlottypes  = Array.isArray(this.props.queryString.p) ? this.props.queryString.p.map((str, i) => ({ value: str, label: str })) : [this.props.queryString.p].map((str, i) => ({ value: str, label: str }))

      this.setState({
        siteIsLoading: true,
        compPlotsEnabled: compPlotsEnabled
      }, () => {
        axios.get(this.props.apiBaseURL + 'get_sites_celery', {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })
        }).then(res => {
          let result = res.data
          let task_id = result.task_id

          this.props.checkTaskStatus(task_id, (result) => {
            this.setState({
              siteIsLoading: false,
              sitePlaceholder: 'Select Site...',
              siteOptions: result.map((site, i) => ({ value: site, label: site })) ,
              selectedSites: querySelectedSites,
              startDate: moment(this.props.queryString.sd),
              endDate: moment(this.props.queryString.ed),
              siteIsDisabled: false,
              siteAllowSelectAll: true,
            },()=>{
              this.updateMenu(querySelectedSites, 'site', 'queryadd', false, ()=> {
                this.setState({
                    selectedClasses: querySelectedClasses,
                  }, ()=>{
                    this.updateMenu(querySelectedClasses, 'class', 'queryadd', false, ()=>{
                      this.setState({
                        selectedFacilities: querySelectedFacilities,
                      }, ()=>{
                        this.updateMenu(querySelectedFacilities, 'facility', 'queryadd', false, ()=>{
                          this.setState({
                            selectedLevels: querySelectedLevels,
                          }, ()=>{
                            this.updateMenu(querySelectedLevels, 'level', 'queryadd', false, ()=>{
                              this.setState({
                                selectedPlottypes: querySelectedPlottypes,
                              }, ()=>{
                                this.updateMenu(querySelectedPlottypes, 'plottype', 'queryadd', true)
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
              
          })
        })
      })
        
      // this.getPlots()
    }
    else{
      this.setState({
        siteIsLoading: true
      }, () => {
        axios.get(this.props.apiBaseURL + 'get_sites_celery', {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })
        }).then(res => {
          let result = res.data
          let task_id = result.task_id

          this.props.checkTaskStatus(task_id, (result) => {
            this.setState({
              siteIsLoading: false,
              sitePlaceholder: 'Select Site...',
              siteOptions: result.map((site, i) => ({ value: site, label: site })) ,
              siteIsDisabled: false,
              siteAllowSelectAll: true,
            })
          })

        });
      });     
    }
  }

  toggleCompPlots(){
  	let curr_state = this.state.compPlotsEnabled
  	this.setState({
  		compPlotsEnabled:!this.state.compPlotsEnabled
  	}, () => {
  		if(this.state.levelOptions.length > 0){

  			this.updateMenu(this.state.levelOptions, 'level', 'queryadd')
  		}
  	})
  }

  updateMenu(selectedOptions, selectName, action, getPlots=false, callback=()=>{}){
  	cancel()
    this.setState({
      getPlotsIsDisabled: true
    })

    let actionIsClear  = action === 'clear' 
    let actionIsRemove = action === 'remove-value'
    let actionIsQuery  = action === 'queryadd'

    let currSelectedSites      = (selectName === 'site')     ? selectedOptions.map((siteObj, i) => (siteObj.value))         : this.state.selectedSites.map((siteObj, i) => (siteObj.value))
    let currSelectedClasses    = (selectName === 'class')    ? selectedOptions.map((classObj, i) => (classObj.value))       : this.state.selectedClasses.map((classObj, i) => (classObj.value))
    let currSelectedFacilities = (selectName === 'facility') ? selectedOptions.map((facilityObj, i) => (facilityObj.value)) : this.state.selectedFacilities.map((facilityObj, i) => (facilityObj.value))
    let currSelectedLevels     = (selectName === 'level')    ? selectedOptions.map((levelObj, i) => (levelObj.value))       : this.state.selectedLevels.map((levelObj, i) => (levelObj.value))
    let currSelectedPlottypes  = (selectName === 'plottype') ? selectedOptions.map((plottypeObj, i) => (plottypeObj.value)) : this.state.selectedPlottypes.map((plottypeObj, i) => (plottypeObj.value))

    let currSiteOptions        = this.state.siteOptions.map((obj, i) => (obj.value))
    let currClassOptions       = this.state.classOptions.map((obj, i) => (obj.value))
    let currFacilityOptions    = this.state.facilityOptions.map((obj, i) => (obj.value))
    let currLevelOptions       = this.state.levelOptions.map((obj, i) => (obj.value))
    let currPlottypeOptions    = this.state.plottypeOptions.map((obj, i) => (obj.value))


    // Check if "all" selected - will use this later to select anything new added 
    let allClassesSelected     = (currSelectedClasses.length    == currClassOptions.length    && currSelectedClasses.length != 0)
    let allFacilitiesSelected  = (currSelectedFacilities.length == currFacilityOptions.length && currSelectedFacilities.length != 0)
    let allLevelsSelected      = (currSelectedLevels.length     == currLevelOptions.length    && currSelectedLevels.length != 0)
    let allPlottypesSelected   = (currSelectedPlottypes.length  == currPlottypeOptions.length && currSelectedPlottypes.length != 0)

    if(selectName === 'site'){
      this.setState({
        'classIsLoading': true,
        'facilityIsLoading': currSelectedClasses.length === 0 ? false : true,
        'levelIsLoading': currSelectedClasses.length === 0 ? false : true,
        'plottypeIsLoading': currSelectedClasses.length === 0 ? false : true,
      })
    }
    else if(selectName === 'class'){
      this.setState({
        'facilityIsLoading': true,
        'levelIsLoading': currSelectedFacilities.length === 0 ? false : true,
        'plottypeIsLoading': currSelectedFacilities.length === 0 ? false : true,
      })
    }
    else if(selectName === 'facility'){
      this.setState({
        'levelIsLoading': true,
        'plottypeIsLoading': currSelectedLevels.length === 0 ? false : true,
      })
    }
    else if(selectName === 'level'){
      this.setState({
        'plottypeIsLoading': true,
      })
    }

    this.setState({
      'datePickerIsDisabled': true
    })
    
    let query_data = {
        'select_name': selectName,
        'sites':currSelectedSites,
        'classes':currSelectedClasses,
        'facilities':currSelectedFacilities,
        'levels':currSelectedLevels,
        'plottypes':currSelectedPlottypes,
        'site_options': currSiteOptions,
        'class_options': currClassOptions,
        'facility_options': currFacilityOptions,
        'level_options': currLevelOptions,
        'plot_options': currPlottypeOptions,
        'incl_comparison': this.state.compPlotsEnabled
      }
    
    axios.post(this.props.apiBaseURL + 'update_pb_menu_options_celery', query_data, {
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    }).then(res => {
      let result = res.data
      let task_id = result.task_id


      this.props.checkTaskStatus(task_id, (result) => {

        let state_update = {}

        state_update['startDate'] = this.state.startDate
        state_update['endDate'] = this.state.endDate

        // SOMETHING ADDED TO REQUEST MENU
        if (action === 'select-option' || actionIsQuery){
          if (result['classes'].length > 0){
            state_update['classOptions'] = result['classes'].map((str, i) => ({ value: str, label: str }))
            state_update['classIsDisabled'] = false
            state_update['classPlaceholder'] = 'Select Class...'
            state_update['classAllowSelectAll'] = true 

            // Set selected classes to all if all was previously selected
            if(allClassesSelected){
            	state_update['selectedClasses'] = state_update['classOptions']
            	currSelectedClasses = result['classes']
            }
          }
          if (result['facilities'].length > 0){
            state_update['facilityOptions'] = result['facilities'].map((str, i) => ({ value: str, label: str }))
            state_update['facilityIsDisabled'] = false
            state_update['facilityPlaceholder'] = 'Select Facility...'
            state_update['facilityAllowSelectAll'] = true 

            // Set selected facilites to all if all was previously selected
            if(allFacilitiesSelected){
            	state_update['selectedFacilities'] = state_update['facilityOptions']
            	currSelectedFacilities = result['facilities']
            }
          }
          if (result['levels'].length > 0){
            state_update['levelOptions'] = result['levels'].map((str, i) => ({ value: str, label: str }))
            state_update['levelIsDisabled'] = false
            state_update['levelPlaceholder'] = 'Select Level...'
            state_update['levelAllowSelectAll'] = true 

            // Set selected levels to all if all was previously selected
            if(allLevelsSelected){
            	state_update['selectedLevels'] = state_update['levelOptions']
            	currSelectedLevels = result['levels']
            }
          }
          if(result['plots'].length > 0){
            state_update['plottypeOptions'] = result['plots'].map((str, i) => ({ value: str, label: str }))
            state_update['plottypeIsDisabled'] = false
            state_update['plottypePlaceholder'] = 'Select Plot Type...'
            state_update['plottypeAllowSelectAll'] = true 

            // Set selected levels to all if all was previously selected
            if(allPlottypesSelected){
            	state_update['selectedPlottypes'] = state_update['plottypeOptions']
            	currSelectedPlottypes = result['plots']
            }
          }
          if(result['dates'].length > 0){
            let momentDates = []
            let includesStartDate = false
            let includesEndDate = false

            for (let dateStr of result['dates']){
              let momentDate = moment(dateStr, "YYYYMMDD")
              momentDates.push(momentDate)

              if (momentDate.isSame(this.state.startDate)){
                includesStartDate = true
              }
              if(momentDate.isSame(this.state.endDate)){
                includesEndDate = true
              }

            }

            let moments = momentDates.map(d => moment(d)),
                maxDate = moment.max(moments),
                minDate = moment.min(moments)

            state_update['minDate'] = minDate
            state_update['maxDate'] = maxDate



            if( !includesStartDate || !includesEndDate){
              state_update['startDate'] = maxDate.clone().subtract(6, 'days')
              state_update['endDate'] = maxDate
            }

            state_update['allDates'] = momentDates
            state_update['datePickerIsDisabled'] = false
          }

          state_update['getPlotsIsDisabled'] = result['dates'].length > 0 ? false : true

          let newPlotRequestData = {
            sites: currSelectedSites,
            classes:  currSelectedClasses,
            facilities: currSelectedFacilities,
            levels: currSelectedLevels,
            plottypes: currSelectedPlottypes,
            sdate: state_update['startDate'].format('YYYYMMDD'),
            edate: state_update['endDate'].format('YYYYMMDD'),
          }
          state_update['plotRequestData'] = newPlotRequestData
          this.props.updateShareLink(state_update['plotRequestData'], this.state.compPlotsEnabled)

          state_update['classIsLoading'] = false
          state_update['facilityIsLoading'] = false
          state_update['levelIsLoading'] = false
          state_update['plottypeIsLoading'] = false

          this.setState(state_update, () => {

            if(!actionIsQuery && this.state.facilityOptions.length > 0 && this.state.selectedFacilities.length === 0){
              this.setState({
                'selectedFacilities': this.state.facilityOptions
              }, () => {
                this.updateMenu(this.state.facilityOptions, 'facility', 'select-option')
              })
              
            }
            else if(!actionIsQuery && this.state.levelOptions.length > 0 && this.state.selectedLevels.length === 0){
             this.setState({
                'selectedLevels': this.state.levelOptions
              }, () => {
                this.updateMenu(this.state.levelOptions, 'level', 'select-option')
              })
            }
            else if(!actionIsQuery && this.state.plottypeOptions.length > 0 && this.state.selectedPlottypes.length === 0){
              this.setState({
                'selectedPlottypes': this.state.plottypeOptions
              }, () => {
                this.updateMenu(this.state.plottypeOptions, 'plottype', 'select-option')
              })
            }

            if(getPlots){
              this.getPlots()
            }
            callback()

          })
        }

        // SOMETHING REMOVED FROM REQUEST MENU
        else if (actionIsClear || actionIsRemove){
          state_update['classOptions'] = result['classes'].map((str, i) => ({ value: str, label: str }))
          state_update['facilityOptions'] = result['facilities'].map((str, i) => ({ value: str, label: str }))
          state_update['levelOptions'] = result['levels'].map((str, i) => ({ value: str, label: str }))
          state_update['plottypeOptions'] = result['plots'].map((str, i) => ({ value: str, label: str }))

          let classHasOptions    = result['classes'].length > 0 
          let facilityHasOptions = result['facilities'].length > 0
          let levelHasOptions    = result['levels'].length > 0
          let plottypeHasOptions = result['plots'].length > 0

          state_update['classIsDisabled']        = classHasOptions    ? false : true
          state_update['facilityIsDisabled']     = facilityHasOptions ? false : true
          state_update['levelIsDisabled']        = levelHasOptions    ? false : true
          state_update['plottypeIsDisabled']     = plottypeHasOptions ? false : true
          state_update['classAllowSelectAll']    = classHasOptions    ? true : false
          state_update['facilityAllowSelectAll'] = facilityHasOptions ? true : false
          state_update['levelAllowSelectAll']    = levelHasOptions    ? true : false
          state_update['plottypeAllowSelectAll'] = plottypeHasOptions ? true : false
          state_update['classPlaceholder']       = classHasOptions    ? 'Select Class...' : '--'
          state_update['facilityPlaceholder']    = facilityHasOptions ? 'Select Facility...' : '--'
          state_update['levelPlaceholder']       = levelHasOptions    ? 'Select Level...' : '--'
          state_update['plottypePlaceholder']    = plottypeHasOptions ? 'Select Plot Type...' : '--'


          let newClassSelections    = [] 
          let newFacilitySelections = []
          let newLevelSelections    = []
          let newPlottypeSelections = []


          if(allClassesSelected && selectName !== "class" && currSelectedClasses.length>0){
          	newClassSelections = result['classes']
          }
          else{
          	for (let dsclass of currSelectedClasses){
  		      if (result['classes'].includes(dsclass)){
  		        newClassSelections.push(dsclass)
  		      }
  			}
  			if(newClassSelections.length == 0){
  				currSelectedFacilities = []
  				currSelectedLevels = []
  				currSelectedPlottypes = []
  			}
          }

      	if(allFacilitiesSelected && selectName !== 'facility' && currSelectedFacilities.length>0){
      		newFacilitySelections = result['facilities']
      	}
      	else{
      		for (let facility of currSelectedFacilities){
  	          if (result['facilities'].includes(facility)){
  	            newFacilitySelections.push(facility)
  	          }
  	        }
  	        if(newFacilitySelections.length == 0){
  				currSelectedLevels = []
  				currSelectedPlottypes = []
  			}
      	}
         
          if(allLevelsSelected && selectName !== 'level' && currSelectedLevels.length>0){
          	newLevelSelections = result['levels']
          }
          else{
          	for (let level of currSelectedLevels){
  	          if (result['levels'].includes(level)){
  	            newLevelSelections.push(level)
  	          }
  	        }
  	        if(newLevelSelections.length == 0){
  				currSelectedPlottypes = []
  			}
          }
          
          if(allPlottypesSelected && selectName !== 'plottype' && currSelectedPlottypes.length>0){
          	newPlottypeSelections = result['plots']
          }
          else{
          	for (let plot of currSelectedPlottypes){
  	          if (result['plots'].includes(plot)){
  	            newPlottypeSelections.push(plot)
  	          }
  	        }
          }
          


          let momentDates = []
          let includesStartDate = false
          let includesEndDate = false

          for (let dateStr of result['dates']){
            let momentDate = moment(dateStr, "YYYYMMDD")
            momentDates.push(momentDate)

            if (momentDate.isSame(this.state.startDate)){
              includesStartDate = true
            }
            if(momentDate.isSame(this.state.endDate)){
              includesEndDate = true
            }

          }

          let moments = momentDates.map(d => moment(d)),
              maxDate = moment.max(moments),
              minDate = moment.min(moments)

          state_update['minDate'] = minDate
          state_update['maxDate'] = maxDate



          if( !includesStartDate || !includesEndDate){
            state_update['startDate'] = maxDate.clone().subtract(6, 'days')
            state_update['endDate'] = maxDate
          }

          state_update['allDates'] = momentDates
          state_update['datePickerIsDisabled'] = momentDates.length > 0 ? false : true


          state_update['selectedClasses']    = newClassSelections.map((str, i) => ({ value: str, label: str }))
          state_update['selectedFacilities'] = newFacilitySelections.map((str, i) => ({ value: str, label: str }))
          state_update['selectedLevels']     = newLevelSelections.map((str, i) => ({ value: str, label: str }))
          state_update['selectedPlottypes']  = newPlottypeSelections.map((str, i) => ({ value: str, label: str }))
          state_update['getPlotsIsDisabled'] = momentDates.length > 0 ? false : true


          let newPlotRequestData = {
            sites: currSelectedSites,
            classes:  newClassSelections,
            facilities: newFacilitySelections,
            levels: newLevelSelections,
            plottypes: newPlottypeSelections,
            sdate: state_update['startDate'].format('YYYYMMDD'),
            edate: state_update['endDate'].format('YYYYMMDD'),
          }
          state_update['plotRequestData'] = newPlotRequestData
          this.props.updateShareLink(state_update['plotRequestData'], this.state.compPlotsEnabled)

          state_update['classIsLoading'] = false
          state_update['facilityIsLoading'] = false
          state_update['levelIsLoading'] = false
          state_update['plottypeIsLoading'] = false

          this.setState(state_update)
          callback()
        }

      })

    });

  }

  handleSiteChange(selectedOptions, action){
    this.setState({
      'selectedSites': selectedOptions
    })
    this.updateMenu(selectedOptions, 'site', action)
  }
  handleClassChange(selectedOptions, action) {
    this.setState({
      'selectedClasses': selectedOptions
    })
    this.updateMenu(selectedOptions, 'class', action)
  }
  handleFacilityChange(selectedOptions, action) {
    this.setState({
      'selectedFacilities': selectedOptions
    })
    this.updateMenu(selectedOptions, 'facility', action)
  }
  handleLevelChange(selectedOptions, action) {
    this.setState({
      'selectedLevels': selectedOptions
    })
    this.updateMenu(selectedOptions, 'level', action)
  }
  handlePlottypeChange(selectedOptions, action) {
    this.setState({
      'selectedPlottypes': selectedOptions
    })
    this.updateMenu(selectedOptions, 'plottype', action)
  }

  handleDateChange({startDate, endDate}){
    startDate = startDate || this.state.startDate
    endDate = endDate || this.state.endDate

    if (startDate.isAfter(endDate)) {
      endDate = startDate
    }

    let newPlotRequestData = {
      sites: this.state.selectedSites.map((siteObj, i) => (siteObj.value)),
      classes: this.state.selectedClasses.map((classObj, i) => (classObj.value)),
      facilities: this.state.selectedFacilities.map((facilityObj, i) => (facilityObj.value)),
      levels: this.state.selectedLevels.map((levelObj, i) => (levelObj.value)),
      plottypes: this.state.selectedPlottypes.map((typeObj, i) => (typeObj.value)),
      sdate: startDate.startOf('day').format('YYYYMMDD'),
      edate: endDate.startOf('day').format('YYYYMMDD'),
    }

    this.setState({ 
      startDate: startDate, 
      endDate: endDate,
      plotRequestData: newPlotRequestData
    })

    this.props.updateShareLink(newPlotRequestData, this.state.compPlotsEnabled)
  }

  handleDateArrowClick(direction, numDays, e){
    //d.add(1, 'days')

    let newSdate = direction === 'left' ? this.state.startDate.clone().subtract(numDays, 'days') : this.state.startDate.clone().add(numDays, 'days')
    let newEdate = direction === 'left' ? this.state.endDate.clone().subtract(numDays, 'days') : this.state.endDate.clone().add(numDays, 'days')

    let newPlotRequestData = {
      sites: this.state.selectedSites.map((siteObj, i) => (siteObj.value)),
      classes: this.state.selectedClasses.map((classObj, i) => (classObj.value)),
      facilities: this.state.selectedFacilities.map((facilityObj, i) => (facilityObj.value)),
      levels: this.state.selectedLevels.map((levelObj, i) => (levelObj.value)),
      plottypes: this.state.selectedPlottypes.map((typeObj, i) => (typeObj.value)),
      sdate: newSdate.startOf('day').format('YYYYMMDD'),
      edate: newEdate.startOf('day').format('YYYYMMDD'),
    }

    this.setState({ 
      startDate: newSdate, 
      endDate: newEdate,
      plotRequestData: newPlotRequestData
    },this.getPlots)

    this.props.updateShareLink(newPlotRequestData, this.state.compPlotsEnabled)
  }

  handleKeyDown(e) {
    if(e.shiftKey){
      this.setState({
        closeOnSelect: false,
        shiftKeyIsPressed: true
      });
    }
  }

  handleKeyUp(e) {
    if(this.state.shiftKeyIsPressed){
      this.setState({
        closeOnSelect: true,
        shiftKeyIsPressed: false
      });
    }
  }
  

  getPlots() {
    this.props.toggleLoadingOverlay()
    let reqData = this.state.plotRequestData
    reqData['incl_comparison'] = this.state.compPlotsEnabled
     axios.post(this.props.apiBaseURL + 'get_pb_plots_celery', reqData, {
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    }).then(res => {
      let result = res.data
      let task_id = result.task_id

      this.props.checkTaskStatus(task_id, (result) => {
        this.props.displayPlots(result)

        this.setState({
          showDateArrows: true,
          dateArrowNumDays: this.state.endDate.diff(this.state.startDate, 'days')+1
        })
        
      })
    });
  }


  render() {
    return <div tabIndex="0" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} style={{height:'100%'}}>
    <div className='menu-header'>
      <h1 className="menu-header-title">DQ-Plotbrowser</h1>
      <h1 style={{display: 'inline-block'}}>Request Options</h1>
      <Tooltip
        title="Shift-Click to select <br>multiple options at once."
        >
        <i className="fas fa-info-circle fa-lg tooltip"></i>
      </Tooltip>
    </div>
    <div className='menu-options-scroll'>
      <Scrollbars style={{ width: '100%', height: '100%'}} >
        <div className='menu-options-inner'>
          <div style={{'paddingBottom': '20px',}}>
            <p className='menu-options-label'>SITE</p>
            <PlotSelectMenuOption
              name = 'site'
              isLoading = {this.state.siteIsLoading}
              onChange = {this.handleSiteChange}
              isMulti={true}
              // defaultValue = {this.state.siteOptions[0]}
              options = {this.state.siteOptions}
              disabled = {this.state.siteIsDisabled || this.state.siteIsLoading}
              placeholder = {this.state.sitePlaceholder}
              value = {this.state.selectedSites}
              closeOnSelect = {this.state.closeOnSelect}
              allowSelectAll = {this.state.siteAllowSelectAll}
            />
            <p className='menu-options-label'>CLASS</p>
            <PlotSelectMenuOption
              name = 'class'
              isLoading = {this.state.classIsLoading}
              isMulti={true}
              onChange = {this.handleClassChange}
              defaultValue = {this.state.classOptions[0]}
              options = {this.state.classOptions}
              disabled = {this.state.classIsDisabled || this.state.classIsLoading}
              placeholder = {this.state.classPlaceholder}
              value = {this.state.selectedClasses}
              closeOnSelect = {this.state.closeOnSelect}
              allowSelectAll = {this.state.classAllowSelectAll}
            />
            <p className='menu-options-label'>FACILITY</p>
            <PlotSelectMenuOption
              name = 'facility'
              isLoading = {this.state.facilityIsLoading}
              isMulti={true}
              onChange = {this.handleFacilityChange}
              defaultValue = {this.state.facilityOptions[0]}
              options = {this.state.facilityOptions}
              disabled = {this.state.facilityIsDisabled  || this.state.facilityIsLoading}
              placeholder = {this.state.facilityPlaceholder}
              value = {this.state.selectedFacilities}
              closeOnSelect = {this.state.closeOnSelect}
              allowSelectAll = {this.state.facilityAllowSelectAll}
            />
            <p className='menu-options-label'>LEVEL</p>
            <PlotSelectMenuOption
              name = 'level'
              isLoading = {this.state.levelIsLoading}
              isMulti={true}
              onChange = {this.handleLevelChange}
              defaultValue = {this.state.levelOptions[0]}
              options = {this.state.levelOptions}
              disabled = {this.state.levelIsDisabled || this.state.levelIsLoading}
              placeholder = {this.state.levelPlaceholder}
              value = {this.state.selectedLevels}
              closeOnSelect = {this.state.closeOnSelect}
              allowSelectAll = {this.state.levelAllowSelectAll}
            />
            <div className="switch-container">
				<div style={{float:"left"}}>
					<p style={{margin:0, lineHeight:"24px", color:"#fafafa"}}>INCLUDE COMPARISON PLOTS</p>
			    </div>
			    <div style={{float:"right"}}>
					<Switch onClick={this.toggleCompPlots} on={this.state.compPlotsEnabled}/>
			    </div>
			</div>
            <p className='menu-options-label'>PLOT TYPE</p>
            <PlotSelectMenuOption
              name = 'plottype'
              isLoading = {this.state.plottypeIsLoading}
              isMulti={true}
              onChange = {this.handlePlottypeChange}
              defaultValue = {this.state.plottypeOptions[0]}
              options = {this.state.plottypeOptions}
              disabled = {this.state.plottypeIsDisabled  || this.state.plottypeIsLoading}
              placeholder = {this.state.plottypePlaceholder}
              value = {this.state.selectedPlottypes}
              closeOnSelect = {this.state.closeOnSelect}
              allowSelectAll = {this.state.plottypeAllowSelectAll}
            />
          </div>
			
          <DateRange
            dateChange = {this.handleDateChange}
            startDate = {this.state.startDate}
            endDate = {this.state.endDate}
            allDates = {this.state.allDates}
            minDate = {this.state.minDate}
            maxDate = {this.state.maxDate}
            disabled= {this.state.datePickerIsDisabled}
          />
          <GetPlotsButton
            disabled = {this.state.getPlotsIsDisabled}
            onClick = {this.getPlots}
          />
          { this.state.showDateArrows ?
          <div className='date-arrow-div'>
            <NextDateArrow
              direction='left'
              numDays={this.state.dateArrowNumDays}
              onClick={this.handleDateArrowClick}
            />
            <NextDateArrow
              direction='right'
              numDays={this.state.dateArrowNumDays}
              onClick={this.handleDateArrowClick}
            />
          </div>
          : null}
        </div>
      </Scrollbars>
      </div>
  </div>
  }
}

class PlotSelectMenuOption extends Component {

  render () {
    return (
      <Select
        isLoading={this.props.isLoading}
        closeMenuOnSelect={this.props.closeOnSelect}
        isMulti={this.props.isMulti}
        styles={customSelectStyles}
        name={this.props.name}
        placeholder={this.props.placeholder}
        defaultValue={this.props.defaultValue}
        onChange={this.props.onChange}
        options={this.props.options}
        isDisabled={this.props.disabled}
        value={this.props.value}
        allowSelectAll={this.props.allowSelectAll}
      />
    )
  }
}

class DateRange extends React.Component {


  isPlotAvailableForDate = (caldate) => {

    for(let date of this.props.allDates) {
      if(caldate.isSame(date)){
        return true
      }
    }

    return false
  }

  handleChangeStart = (startDate) => this.props.dateChange({ startDate })
  handleChangeEnd = (endDate) => this.props.dateChange({ endDate })

  render () {
    return <div>
      <div id='sdate-div'>
        <p className='menu-options-label'>START DATE</p>
        <DatePicker
          dateFormat= "YYYY-MM-DD"
          filterDate={this.isPlotAvailableForDate}
          disabled={this.props.disabled}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          selected={this.props.startDate}
          selectsStart
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onChange={this.handleChangeStart}
          className="date-input"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      </div>
      <div id='edate-div'>
        <p className='menu-options-label'>END DATE</p>
        <DatePicker
          dateFormat= "YYYY-MM-DD"
          filterDate={this.isPlotAvailableForDate}
          disabled={this.props.disabled}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          selected={this.props.endDate}
          selectsEnd
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onChange={this.handleChangeEnd} 
          className="date-input"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      </div>
    </div>
  }
}

class GetPlotsButton extends React.Component {

  render(){
    return <div className='plot-menu-button-div'>
      <button disabled={this.props.disabled} onClick={this.props.onClick} className='plot-menu-button'>Get Plots</button>
    </div>
  }
}

class NextDateArrow extends React.Component {
  render() {
    let divClass  = this.props.direction + '-arrow'
    let iconClass = "fa fa-arrow-circle-" + this.props.direction + " fa-2x date-arrow-icon"
    let arrowText = this.props.direction === 'left' ? 'prev ' + this.props.numDays + ' days' : 'next ' + this.props.numDays + ' days'
    if(this.props.numDays === 1){
      arrowText = this.props.direction === 'left' ? 'prev day' : 'next day'
    }

    return <div onClick={(e) => this.props.onClick(this.props.direction, this.props.numDays, e)} className={divClass}>
      {this.props.direction === 'left' ? <i className={iconClass} aria-hidden="true"></i> : <p className='date-arrow-text'>{arrowText}</p>}
      {this.props.direction === 'left' ? <p className='date-arrow-text'>{arrowText}</p>   : <i className={iconClass} aria-hidden="true"></i>}
    </div>
  }
}

class PlotDisplay extends React.Component {

  render() {
    return Object.keys(this.props.plotDisplayData).map((dsname, i) => (
        <div key={dsname} className='plot-section'>
          <p className='plot-section-label'>Datastream: {dsname}</p>
          <div className='plot-section-wrapper'>
            <PlotSection key={dsname} dailyMaxPlots={this.props.dailyMaxPlots} videoThumbBaseURL={this.props.videoThumbBaseURL} baseURL={this.props.baseURL} sectionData={this.props.plotDisplayData[dsname]}/>
          </div>
        </div>
    ));
  }
}

class PlotSection extends React.Component {

  render() {
    return Object.keys(this.props.sectionData).map((plotname, i) => (
      <div key={plotname} className='plot-row'>
        <p style={{display: 'inline-block'}} className='plot-row-label'>{plotname}</p>
        {this.props.sectionData[plotname]['description'] !== 'No plot description' ?
          <Tooltip
            title={this.props.sectionData[plotname]['description']}
          >
            <i style={{paddingLeft:5}} className="fas fa-info-circle fa-md"></i>
          </Tooltip>
        :
          null
        }
        <div key={plotname} className='plot-row-plots'>
          <PlotRow key={plotname} dailyMaxPlots={this.props.dailyMaxPlots} videoThumbBaseURL={this.props.videoThumbBaseURL} baseURL={this.props.baseURL} rowData={this.props.sectionData[plotname]}/>
        </div>
      </div>
    ));
  }
}

class PlotRow extends React.Component {
  constructor(props){
    super(props)
    this.state = { currentImage: 0, lightboxIsOpen: false };

    this.openLightbox  = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.thumbClick = this.thumbClick.bind(this)
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrev = this.gotoPrev.bind(this);

  }

  openLightbox(e) {
    this.setState({
      currentImage: parseInt(e.currentTarget.getAttribute('data-index')),
      lightboxIsOpen: true,
    }); 
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    }); 
  }
  gotoPrev() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    }); 
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1, 
    }); 
  }

  thumbClick(i) {
    this.setState({
      currentImage: i
    });
  }

  imgClick(e) {
    window.open(e.currentTarget.src);
  }

  render() {
    let images = []
    // let plot_index = -1

    Object.keys(this.props.rowData).map(function(date, i){
      let num_images = 0

      if (date !== 'description'){
        if(this.props.rowData[date].length === 0){
          images.push({src: BlankScreenGrey, caption:date, url:null})
          num_images++
        }
        else{
          for (let j=0; j<this.props.rowData[date].length; j++){
            images.push({src: this.props.baseURL + this.props.rowData[date][j], caption:date, url:this.props.rowData[date][j]})
            num_images++
          }
        }
        // add extra empty plots to match up times if there are datastreams w/ more than 1 plot per day
        for (let j=0; j<this.props.dailyMaxPlots[date] - num_images; j++){
          images.push({src: BlankScreenGrey, caption:date, url:null})
        }
      }
      
      
    }, this)

    

    return (
      <div>
        <Lightbox
          images={images}
          isOpen={this.state.lightboxIsOpen}
          onClickPrev={this.gotoPrev}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          onClose={this.closeLightbox}
          onClickThumbnail={this.thumbClick}
          onClickImage={this.imgClick}
          theme={customLightboxStyles}
          backdropClosesModal={true}
          showThumbnails={false}
          zoomable={true}
        />
        {
          images.map((img_obj, i) => (
            <div key={img_obj.caption+'_'+i} className='plot'>
              <Plot onClick={this.openLightbox} index={i} key={img_obj.caption+'_'+i} videoThumbBaseURL={this.props.videoThumbBaseURL} baseURL={this.props.baseURL} url={img_obj.url}/>
              <p className='plot-date'>{img_obj.caption}</p>
            </div>
          )) 
        }
    </div>
    )
  }
}

class Plot extends React.Component {

	constructor(props){
		super(props)
		this.state ={
			loaded: false,
			isShowingOverlay: true,
      embedMovie: null,
      isMovie: false,
      inView: false,
		}
    this.imageExists = this.imageExists.bind(this);
    this.observerRef = React.createRef();
    this.observer = null;
	}

  componentDidMount() {
    // Detect movie type but defer thumbnail check until in view
    try {
      if (this.props.url && this.props.url.split('.').pop() === 'mp4') {
        this.setState({ isMovie: true });
      }
    } catch(err) {
      this.setState({ isMovie: false, embedMovie: false });
    }

    // Set up IntersectionObserver to lazy-load images as they scroll into view.
    // rootMargin of 300px means loading begins slightly before the image is visible.
    if (this.observerRef.current) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.setState({ inView: true });
            this.observer.disconnect();
            this.observer = null;
          }
        },
        { rootMargin: '300px' }
      );
      this.observer.observe(this.observerRef.current);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Once in view, trigger the movie thumbnail network check
    if (!prevState.inView && this.state.inView && this.state.isMovie) {
      this.imageExists(
        this.props.videoThumbBaseURL +
        this.capitalizeSiteCode(this.props.url.substr(0, this.props.url.lastIndexOf('.')) + '.png')
      );
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

	handleImageLoaded = () => {
		this.setState({
			isShowingOverlay: false
		},()=>{
			this.setState({
				loaded: true
			})
		})
	}

	capitalizeSiteCode = (url) => {
    	return url && url.substring(0, 3).toUpperCase() + url.slice(3);
	}

  imageExists(imgUrl) {
    if (!imgUrl) {
        return false;
    }
    new Promise(res => {
        const image = new Image();
        image.onload = () => this.setState({embedMovie: false});
        image.onerror = () => this.setState({embedMovie: true});
        image.src = imgUrl;
    });
  }

  // doesn't work cross-origin 
  checkFile = (url) => {
    try {
      axios.get(url).then(() => {
          this.setState({
            embedMovie: false
          })
        })
        .catch(err => {
          console.log(err)
          this.setState({
            embedMovie: true
          })
        });
      }
    catch (error) {
      console.log(error)
      this.setState({
        embedMovie: true
      })
    }
  };

  render() {
    // No-plot placeholder: just an icon, no network request needed
    if (this.props.url === null) {
      return <i style={{textAlign:'center', paddingBottom:20, color:'#a91717'}} className="fas fa-times fa-3x plot-img"></i>;
    }

    // Lazy loading: attach observerRef to the wrapper so IntersectionObserver
    // can detect when this plot scrolls into view before firing image requests.
    return (
      <div ref={this.observerRef} style={{minHeight: 55}}>
        {!this.state.inView ? (
          // Placeholder spinner shown until the plot scrolls near the viewport
          <div className="plot-load-indicator">
            <i className="fas fa-2x fa-spinner plot-img fa-spin"></i>
          </div>
        ) : this.state.isMovie ? (
          <div>
            <div style={this.state.isShowingOverlay ? {display:"block"} : {display:"none"}} className="plot-load-indicator">
              <i className="fas fa-2x fa-spinner plot-img fa-spin"></i>
            </div>
            <div style={this.state.loaded ? {visibility:"visible"} : {visibility:"hidden"}} className="plot-img-container">
              {this.state.embedMovie !== null ?
                this.state.embedMovie ?
                  <video preload="metadata" playsinline autoplay muted loop onLoadedData={this.handleImageLoaded} className='plot-img' onClick={this.props.onClick} data-index={this.props.index}>
                    <source src={this.props.baseURL + this.props.url + '#t=0.001'} type="video/mp4"></source>
                  </video>
                :
                  <img onLoad={this.handleImageLoaded} onClick={this.props.onClick} data-index={this.props.index} className='plot-img' src={this.props.videoThumbBaseURL + this.capitalizeSiteCode(this.props.url.substr(0, this.props.url.lastIndexOf(".")) + ".png")}/>
                :
                null
              }
            </div>
          </div>
        ) : (
          <div>
            <div style={this.state.isShowingOverlay ? {display:"block"} : {display:"none"}} className="plot-load-indicator">
              <i className="fas fa-2x fa-spinner plot-img fa-spin"></i>
            </div>
            <div style={this.state.loaded ? {visibility:"visible"} : {visibility:"hidden"}} className="plot-img-container">
              <img onLoad={this.handleImageLoaded} onClick={this.props.onClick} data-index={this.props.index} className='plot-img' src={this.props.baseURL + this.props.url}/>
            </div>
          </div>
        )}
      </div>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js